<template>
    <div>
        <div class="user-info-g">
            <div class="user-img">
                <img src="/assets/chat/user_basic.png" alt="">
            </div>
            <div>
                <div class="logged-in-t">logged in as</div>
                <div class="user-name">{{user.fname}}</div>
            </div>
            <div class="act-btns" @click="disconnectAllUsers"><div class="btn dl">Disconnect All Users</div></div>
        </div>
        <div class="active-m">
            <div class="title">Active Moderators ({{filteredModerators.length}})</div>
            <!-- <div class="active-moderator-g">
                <div class="all-g" v-for="m in moderators">
                    <div class="user-img"><img width="50px" height="55px" src="/assets/chat/user_basic.png" alt=""></div>
                    <div class="user-title">{{m.user.name}}</div>
                </div>
            </div> -->
            <div class="active-moderator-g">
            <div
                class="all-g"
                v-for="m in moderators"
                :key="m.user.id"
            >
                <div class="user-img">
                <img width="50" height="55" src="/assets/chat/user_basic.png" alt="" />
                </div>
                <div class="user-title">{{ m.user.name }}</div>
            </div>
            </div>

        </div>
        <div class="blocked-v">
            <div class="title">Blocked Viewers ({{filteredBlockedUsers.length}})</div>
            <!-- <div class="blocked-viewers-g">
                <div class="all-g" v-for="user in filteredBlockedUsers">
                    <div class="image"><img width="50px" height="55px" src="/assets/chat/user_basic.png" alt=""></div>
                    <div class="user-title">{{user.user.name}}</div>
                    <div class="unblock" style="cursor: pointer" v-if="user.user.userData.block == 1" @click="blockUser(user.user.userData.user_id)"><img src="/assets/new-moderator/Button-Unblock.svg " alt="">Unblock</div>
                </div>
            </div> -->
            <div class="blocked-viewers-g">
                <div
                    class="all-g"
                    v-for="user in filteredBlockedUsers"
                    :key="user.user.userData.user_id"
                >
                    <div class="image">
                    <img width="50" height="55" src="/assets/chat/user_basic.png" alt="">
                    </div>

                    <div class="user-title">
                    {{ user.user.name }}
                    </div>

                    <div
                    class="unblock"
                    style="cursor: pointer"
                    v-if="user.user.userData.block == 1"
                    @click="blockUser(user.user.userData.user_id)"
                    >
                    <img src="/assets/new-moderator/Button-Unblock.svg" alt="">
                    Unblock
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    props : ['user','moderators','normalUsers'],
    data() {
        return {
            searchUser : null,
        }
    },
    computed :{
        filteredBlockedUsers(){
            let tempMembers = this.normalUsers;
            let seen = new Set()
            if (this.searchUser != '' && this.searchUser) {
                tempMembers = tempMembers.filter((mem) => {
                    return mem.user.name
                        .toUpperCase()
                        .includes(this.searchUser.toUpperCase())
                });

                tempMembers = tempMembers.sort((a, b) => {
                    let fa = a.user.name.toLowerCase(), fb = b.user.name.toLowerCase()

                    if (fa < fb) {
                        return -1
                    }
                    if (fa > fb) {
                        return 1
                    }
                    return 0
                });

            }
            tempMembers = tempMembers.filter(el => {
                let duplicate = seen.has(el.user.userData.user_id)
                seen.add(el.user.userData.user_id)
                return !duplicate && el.user.userData.block == 1;
            })
            return tempMembers;
        },
        filteredUsers(){
            let tempMembers = this.normalUsers;
            let seen = new Set()
            if (this.searchUser != '' && this.searchUser) {
                tempMembers = tempMembers.filter((mem) => {
                    return mem.user.name
                        .toUpperCase()
                        .includes(this.searchUser.toUpperCase())
                });

                tempMembers = tempMembers.sort((a, b) => {
                    let fa = a.user.name.toLowerCase(), fb = b.user.name.toLowerCase()

                    if (fa < fb) {
                        return -1
                    }
                    if (fa > fb) {
                        return 1
                    }
                    return 0
                });

            }
            tempMembers = tempMembers.filter(el => {
                let duplicate = seen.has(el.user.userData.user_id)
                seen.add(el.user.userData.user_id)
                return !duplicate && el.user.userData.block == 0;
            })
            return tempMembers;
        },
        filteredModerators(){
            let tempModerators = this.moderators;
            if (this.searchUser != '' && this.searchUser) {
                tempModerators = tempModerators.filter((mem) => {
                    return mem.user.name
                        .toUpperCase()
                        .includes(this.searchUser.toUpperCase())
                });

                tempModerators = tempModerators.sort((a, b) => {
                    let fa = a.user.title.toLowerCase(), fb = b.user.title.toLowerCase()

                    if (fa < fb) {
                        return -1
                    }
                    if (fa > fb) {
                        return 1
                    }
                    return 0
                });
            }
            return tempModerators;
        }
    },
    methods : {
        blockUser(id){
            this.$emit('blockUserStatus',id);
        },
        getBlockedLength(v){
            let users = v.filter((mem) => {
                return mem.user.userData.block == 1;
            });
            return users.length;
        },
        disconnectAllUsers(){      
            this.$emit("disconnectUsers");
        }
    }
}
</script>
<style scoped>
    .logged-in-t {
        font-size: 12px;
        font-weight: 500;
        color: #9B9B9B;
    }
    .user-name {
        font-size: 18px;
        font-weight: 600;
    }
    .act-btns {
        grid-column: 1 / 4;
        display: flex;
        justify-content: space-between;
        grid-gap: 5px;
    }
    .dl {
        display: inline-flex;
        background: #FFE2E5;
        color: #F64E60;
        font-weight: 600;
        font-size: 14px;
    }
    .user-info-g{
        display: grid;
        grid-template-columns: 44px 1fr;
        grid-gap: 8px;
        padding-bottom: 12px;
        border-bottom: 2px dashed #E4E6EF;
    }
    .active-m, .blocked-v {
        padding-top: 8px;
        padding-bottom: 12px;
        border-bottom: 2px dashed #E4E6EF;
    }
    .active-m .title, .blocked-v .title {
        font-size: 14px;
        font-weight: 500;
        color: #9B9B9B;
        margin-bottom: 4px;
    }
    .active-moderator-g, .blocked-viewers-g {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(4rem, 1fr));
        grid-gap: 10px;
        text-align: center;
    }
</style>
